angular.module('wbDashboard').controller('PlanningMortgageControllerAurea', ['$scope', '$timeout', '$uibModal', '$q', '$window', 'PlanningService', 'ThinkingService', 'CommonConstant', 'Message', 'Request', 'Track', function ($scope, $timeout, $uibModal, $q, $window, PlanningService, ThinkingService, CommonConstant, Message, Request, Track) {

    $scope.mortgage = {
        interest_rate: null,
        term: null,
        timer: null,
        showAnyway: null
    };

    $scope.pageData = {
        sending: false,
        updatingSavings: false,
        showTerm: false,
        thinking: false,
        modalInstance: null,
    };
    $scope.forms = {};

    $scope.options = {
    };

    $scope.recommendationSlug = $scope.$stateParams.recommendationSlug ? $scope.$stateParams.recommendationSlug : PlanningService.partnerInfo.mortgage.slug;


    $scope.showLoading = function() {
        $scope.pageData.thinking = true;
        ThinkingService.open($scope, "mortgage", {thinking:"Finding Your Recommend Policy", complete:"Complete!"});
    };

    $scope.mortgageModal = function() {
        $scope.year = new Date().getFullYear();

        $scope.pageData.modalInstance = $uibModal.open({
            templateUrl: 'app/themes/aurea/segments/planning/planning.partner.mortgage.disclosure.tpl.html',
            scope: $scope,
            size: 'md',
            windowClass:'mortgage-disclosure-modal'
        });
        $scope.pageData.modalInstance.result.catch(angular.noop);
    };

    $scope.submitToPartner = function() {

        Track.send("Send to Partner", "planning", {partner: $scope.mortgage.referral_partner});

        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).finally(function() {
            // angular.element("form[name='forms.mortgage']").submit();
            $window.location.href = $scope.mortgage.referral_url;
        });
    };

    $scope.complete = function() {
        $scope.pageData.sending = true;
        PlanningService.completeRecommendation($scope.recommendationSlug).then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).finally(function() {
            $scope.$state.go('base.planning');
        });
    };

    $scope.dismiss = function() {
        $scope.pageData.sending = true;
        PlanningService.dismissRecommendation($scope.recommendationSlug, "Should Not Refinance").then(function() {
            return PlanningService.retrieveRecommendations(true);
        }).finally(function() {
            $scope.$state.go('base.planning');
        });
    };

    $scope.goNextPage = function() {
        switch ($scope.$stateParams.page) {
            case 'difficulty':
            case 'adjust':
                if ($scope.mortgage.found_referral) {
                    if ($scope.mortgage.referral_partner === 'axos') {
                        $scope.$state.go('.', {page: 'introducing-axos'});
                    } else {
                        $scope.$state.go('.',{page:'introducing-no-one'});
                    }
                } else {
                    $scope.$state.go('.',{page:'introducing-no-one'});
                }
                break;
        }

    };

    init();

    function init() {

        $scope.$watchGroup(['mortgage.interest_rate','mortgage.term'], function (values) {
            var rate = values[0], term = values[1];

            if (rate || term) {
                $scope.pageData.updatingSavings = true;

                $timeout.cancel($scope.mortgage.timer);
                $scope.mortgage.timer = $timeout(function () {
                    //need to create manual debounce
                    updateSavings(rate, term);
                }, 750);
            }
        });

        $scope.showLoading();

        $q.all([getRecommend(), updateInterest(), updateSavings()]).then(function() {
            $scope.pageData.thinking = false;

            if ($scope.mortgage.showAnyway) {
                $scope.$state.go(".", {page: "difficulty"}, {location: "replace"});
            } else {
                $scope.$state.go(".", {page: "adjust"}, {location: "replace"});
            }

        }).then(function() {
            ThinkingService.close(false, 'mortgage');
        });


    }

    function updateInterest() {
        $scope.pageData.sending = true;

        return Request.make('mortgage_refi_interest').then(function(response) {
            var data = response.data;

            $scope.mortgage.showAnyway = data.show_calculation || data.show_over_term_limit;
            $scope.mortgage.showTerms = !data.show_over_term_limit;

            $scope.mortgage.monthly_payments = data.monthly_payments;
            $scope.mortgage.accruing_monthly_interest = data.accruing_monthly_interest;

        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    }

    function updateSavings(rate, term) {
        $scope.pageData.sending = true;
        $scope.pageData.updatingSavings = true;

        return Request.make('mortgage_refi_savings', {interestRate: rate, term: term}).then(function(response) {
            /**
             * @param {Object} data
             * @param {int} data.est_monthly_savings
             * @param {int} data.est_total_savings
             * @param {bool} data.extending_term
             * @param {int} data.interest_rate
             * @param {int} data.max_interest_rate
             * @param {int} data.min_interest_rate
             * @param {string} data.refinance_purpose
             * @param {int} data.term
             */
            var data = response.data;
            //convert all values to numerics
            data.est_monthly_savings *= 1;
            data.est_total_savings *= 1;
            data.interest_rate *= 1;
            data.max_interest_rate *= 1;
            data.min_interest_rate *= 1;

            if (    (!$scope.mortgage.interest_rate && !$scope.mortgage.term)
                 || ($scope.mortgage.interest_rate === data.interest_rate && $scope.mortgage.term === data.term)
            ) {
                //in case it was changed since requested
                angular.extend($scope.mortgage, data);

                //need calculated for ticks on slider
                $scope.mortgage.interest_rate_33 = PlanningService.round05(($scope.mortgage.max_interest_rate-$scope.mortgage.min_interest_rate)*0.33+$scope.mortgage.min_interest_rate);
                $scope.mortgage.interest_rate_66 = PlanningService.round05(($scope.mortgage.max_interest_rate-$scope.mortgage.min_interest_rate)*0.66+$scope.mortgage.min_interest_rate);
                $scope.mortgage.min_interest_rate = PlanningService.round05($scope.mortgage.min_interest_rate, true);
                $scope.mortgage.max_interest_rate = PlanningService.round05($scope.mortgage.max_interest_rate);


                if ($scope.mortgage.refinance_purpose === "lower-payment" && $scope.mortgage.extending_term) {
                    $scope.mortgage.showRate = true;
                    $scope.mortgage.headerText = "Lower Your Payments";
                    $scope.mortgage.subText = "Aim to refinance at " + $scope.mortgage.max_interest_rate + "% or lower to save.";
                }
                if ($scope.mortgage.refinance_purpose === "lower-payment" && !$scope.mortgage.extending_term) {
                    $scope.mortgage.showRate = true;
                    $scope.mortgage.headerText = "Lower Your Payments";
                    $scope.mortgage.subText = "Refinance at " + $scope.mortgage.max_interest_rate + "% or lower to save.";
                }
                if ($scope.mortgage.refinance_purpose === "lower-rate") {
                    $scope.mortgage.showRate = true;
                    $scope.mortgage.headerText = "Lower Your Rate";
                    $scope.mortgage.subText = "Aim to refinance at " + $scope.mortgage.max_interest_rate + "% or lower to save.";
                }
                if ($scope.mortgage.refinance_purpose === "pay-off-faster") {
                    $scope.mortgage.showTerm = true;
                    $scope.mortgage.headerText = "Pay It Off Faster";
                    $scope.mortgage.subText = "Refinance at " + $scope.mortgage.max_interest_rate + "% and accelerate your payback to save.";
                }

            }
        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
            $scope.pageData.updatingSavings = false;
        });

    }

    function getRecommend() {
        $scope.pageData.sending = true;

        return Request.make('mortgage_refi_recommend').then(function(response) {
            var data = response.data;

            angular.extend($scope.mortgage, data);

        }).catch(function() {
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    }

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.mortgage' }, function(trans) {
        if (trans.params('to').page === "submit") {
            //get token?
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
